<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <template v-if="page">
          <h1 class="text-title-underline">{{ page.title }}</h1>
          <div class="v-html whitespace-pre-wrap mb-6" v-html="page.body" />
        </template>
        <template v-else>
          ページが見つかりませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { axios, ApiResponse } from '@/plugins/axios'
import { PageAttributes } from '@/types/models/page'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth
  },
  setup() {
    const route = useRoute()
    const page = ref<PageAttributes | undefined>()

    onMounted(() => {
      axios
        .get<ApiResponse<PageAttributes>>(`/page/${route.params.page_id}`)
        .then(response => {
          page.value = response.data.payload
        })
    })

    return {
      page
    }
  }
})
</script>
